// extracted by mini-css-extract-plugin
module.exports = {"feedbackButtons":"FeedbackButtons_feedbackButtons__1hbTV","feedbackButtonImage":"FeedbackButtons_feedbackButtonImage__1YG2U"};